require('@js/homepage-init');
